
import { defineComponent, PropType } from "vue";
import EventBusService from "@/services/EventBusService";
import VoucherService from "@/services/VoucherService";
import { VoucherRedemptionCheckResult } from "@/data/voucher";
import VoucherCheck from "@/components/voucher/VoucherCheck.vue";
import ProductCard from "@/components/ProductCard.vue";
import GlobalStore from "@/utils/global-store";

type Form = {
    code: string,
};

// type FormErrors = Record<string, string[]>;

declare interface VoucherRedemptionModalData {
    loadingRedemption: boolean,
    shownLocal: boolean,

    form: Form,

    // errors: FormErrors,

    result: VoucherRedemptionCheckResult|null,

    showSuccess: boolean,
}

export default defineComponent({
    name: 'VoucherRedemptionModal',
    components: {
        ProductCard,
        VoucherCheck,
        // TextField,
    },
    emits: [
        'redeemed',
        'close',
    ],
    props: {
        shown: {
            type: Boolean,
            required: true,
        },
    },
    data(): VoucherRedemptionModalData {
        return {
            loadingRedemption: false,
            shownLocal: true,
            form: {
                code: '',
            },
            // errors: {},
            result: null,
            showSuccess: false,
        };
    },
    computed: {
        /*hasErrors() {
            return Object.keys(this.errors).length > 0;
        }*/
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        onValidVoucher(result: VoucherRedemptionCheckResult) {
            this.result = result;
        },
        submitRedemption() {
            if( this.loadingRedemption || !this?.result?.code ) {
                return;
            }

            //this.errors = {};
            this.loadingRedemption = true;
            VoucherService.redeemVoucher(this?.result?.code || '').then((resp) => {
                /*
                EventBusService.$notification({
                    type: 'success',
                    message: 'Der Gutschein wurde erfolgreich eingelöst.',
                });
                */

                this.showSuccess = true;

                this.form.code = '';
                GlobalStore.set('voucherCode', ''); // @TODO: move to DRY-up

                EventBusService.$emit('user.credits:changed');
                EventBusService.$emit('user.courses.enrollment:changed');

                this.$emit('redeemed');

            }).catch(error => {
                if( error.response.status === 429 ) { // Too Many Requests (rate limited)
                    EventBusService.$notification({
                        type: 'error',
                        message: 'Zu viele Anfragen. Bitte versuche es in wenigen Sekunden noch einmal.',
                    });
                    return;
                }

                EventBusService.$notification({
                    type: 'error',
                    message: 'Es ist ein Fehler beim Einlösen aufgetreten.',
                });

                /*if( error.response.status === 404 ) {
                    this.errors = {
                        code: ['Ungültiger Gutscheincode'],
                    };
                }*/
            }).finally(() => this.loadingRedemption = false);
        }
    },
    watch: {
        shown: {
            handler(val) {
                if( val ) {
                    this.showSuccess = false; // reset success display
                    this.result = null;
                }
                this.shownLocal = val;
            },
            immediate: true,
        },
    },
});
